/*
 * @Author: your name
 * @Date: 2021-03-09 09:54:28
 * @LastEditTime: 2021-05-28 14:25:32
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \txm-manager-fe\src\plugins\myplugin.js
 */
let myplugin = {
  install: function (Vue) {
    Vue.prototype.getDomain = function(){
      return process.env.VUE_APP_BASE_API
    }
    // 将时间从秒转换为年月日时分秒
    // detail为false则精确到日期
    Vue.prototype.timeTransform = function (time, detail = true) {
      const d = new Date(time * 1000)
      return d.getFullYear() + '-' +
        (d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1) + '-' +
        (d.getDate() < 10 ? '0' + d.getDate() : d.getDate()) + ' ' +
        (detail ? ((d.getHours() < 10 ? '0' + d.getHours() : d.getHours()) + ':' +
          (d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes()) + ':' +
          (d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds())) : '')
    }
    Vue.prototype.__axios = (url, params = {}, handle = () => { }, loadings = () => { }, errorHandler) => {
      Object.assign(params, { token: sessionStorage.token })
      Vue.prototype.axios.post(url, params).then(res => {
        if (res.data.err_code === 0) {
          handle(res)
        } else if (res.data.err_code === 50000) {
          Vue.prototype.$message({
            type: 'error',
            message: '登录过期，请重新登录'
          })
        } else if (res.data === '<html><title>404: OK</title><body>404: OK</body></html>') {
          Vue.prototype.$message({
            type: 'error',
            message: '接口不存在'
          })
        } else if (errorHandler) {
          errorHandler(res)
        } else {
          Vue.prototype.$message({
            type: 'error',
            message: res.data.content.desc || res.data.content.data
          })
        }
        loadings()
      }).catch(err => {
        Vue.prototype.$message({
          type: 'error',
          message: err.message
        })
        loadings()
      })
    }
    Vue.prototype.__confirm = (info, act, params = [], onCancel = () => { }, useHtml = false) => {
      Vue.prototype.$confirm(info, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: useHtml,
        type: 'warning'
      }).then(() => {
        act(...params)
      }).catch(() => {
        onCancel()
      })
    }
  }
}

export default myplugin
